import { db, firebaseAuth } from './firebaseConfig';
import I18n from 'core/I18n/I18n';
import keyEnum from 'core/I18n/KeyEnum';
import EntityEnum from './EntityEnum';
import { getItem, addItem, deleteItem, updateItem, execute } from './firebaseFunctions';
import { groupReference } from 'core/database/user';
import { normalizeCombo } from 'core/utils/Utils';

export const getTemplate = async (fields) => {
    const table = db.collection("Templates").doc(fields.id)
    return execute(table).then(items => {
        const groups = [];
        const item = items[0];
        item.groups.map(groupItem => {
            if (groupItem && groupItem.group) {
                groups.push(execute(groupItem.group));
            }
        })

        return Promise.all(groups).then(arrGroups => {
            const groups = [].concat(...arrGroups).filter(item => item.active === true);
            return {...item, groups};
        });
    });
}

export const getEvaluationTemplates = async (scope) => {
    if (scope && scope.value) {
        const table = db.collection("Templates").where("active", "==", true).where("autoEvaluation", "==", true);
        const clauseHasPower = table.where("groups", 'array-contains', { group: groupReference(scope) });

        const templates = await execute(clauseHasPower);

        const promises = templates.map(item => {
            const groups = [];
            item.groups.map(groupItem => {
                if (groupItem && groupItem.group) {
                    groups.push(execute(groupItem.group));
                }
            })

            return Promise.all(groups).then(arrGroups => {
                const groups = [].concat(...arrGroups).filter(item => item.active === true);
                const index = templates.findIndex(data => data.id === item.id);
                templates[index].groups = groups;
                return;
            });
        });

        return Promise.all(promises).then(() => templates);
    } else {
        throw new Error(I18n[keyEnum.groupFieldRequired]);
    }
}

export const getTemplates = async (scope) => {
    if (scope && scope.value) {
        const table = db.collection("Templates").where("active", "==", true);
        const clauseHasPower = table.where("groups", 'array-contains', { group: groupReference(scope) });

        const templates = await execute(clauseHasPower);

        const promises = templates.map(item => {
            const groups = [];
            item.groups.map(groupItem => {
                if (groupItem && groupItem.group) {
                    groups.push(execute(groupItem.group));
                }
            })

            return Promise.all(groups).then(arrGroups => {
                const groups = [].concat(...arrGroups).filter(item => item.active === true);
                const index = templates.findIndex(data => data.id === item.id);
                templates[index].groups = groups;
                return;
            });
        });

        return Promise.all(promises).then(() => templates);
    } else {
        throw new Error(I18n[keyEnum.groupFieldRequired]);
    }
}

export const deleteTemplate = async ({ id, groups, scope }) => {
    const newGroups = groups.filter(item => item.id !== scope.value);
    return addOrUpdate({ id, groups: normalizeCombo("id", "name", newGroups) });
}

export const updateTemplate = async (item) => {
    let { name, description } = item;

    const groups = [];
    item.groups.map(item => {
        groups.push({ group: groupReference(item) })
    })
    //descrição não pode ser nulo
    description = description ? description : "";

    return addItem("Templates", { name, description, groups });
}

export const addOrUpdate = async (item) => {
    let { id, name, description, categories, analysisType, analysis } = item;

    const groups = [];
    item.groups.map(item => {
        groups.push({ group: groupReference(item) })
    })

    const data = { ...item, groups };
    if(id){
        data['id'] = id;
    }
    if(description){
        data['description'] = description;
    }
    if(categories){
        data['categories'] = categories;
    }
    if(analysisType){
        data['analysisType'] = analysisType;
    }
    if(analysis){
        data['analysis'] = analysis;
    }

    if (id) {
        return updateItem("Templates", data);
    } else {
        return addItem("Templates", data);
    }
}
export const templateReference = (item) => {
    return db.collection("Templates").doc(item.value);
}


/**
 * const users = db.collection(EntityEnum.user);
    const query = users.where('invite', '==', true);

    return query.get().then(snapshot => {
        if (snapshot.empty) {
            return;
        } else {
            snapshot.docs.forEach(document => {
                if (document.exists && document.id === id) {
                    return document;
                } else {
                    throw new Error(I18n[keyEnum.inviteExpired]);
                }
            });
            return;
        }
    })
 */